import React, { useCallback } from 'react';
import { Box, TextV2 } from '@withjoy/joykit';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { Bell } from '@withjoy/joykit/icons';
import { usePriceAlertModal } from '../PriceAlertModalContext';
import { useEventInfo } from '@shared/utils/eventInfo';
import { differenceInCalendarDays } from 'date-fns';
import { usePriceAlertsActive } from '@shared/components/PriceAlertModal/usePriceAlertsActive';

export const PriceAlertsAction: React.FC = () => {
  const { onOpen } = usePriceAlertModal();
  const telemetry = useGuestGuideTelemetry();
  const { tq } = useTranslation('guestGuide');
  const { eventInfo } = useEventInfo();

  const ms = eventInfo?.finalizedDate?.milliseconds;
  const daysUntilEvent = ms != null ? Math.max(0, differenceInCalendarDays(ms, Date.now())) : undefined;
  const isFarOut = daysUntilEvent === undefined || daysUntilEvent > 180;
  const priceAlertsActive = usePriceAlertsActive();

  const handleClick = useCallback(() => {
    telemetry.clickPriceAlerts();
    onOpen();
  }, [telemetry, onOpen]);

  if (!priceAlertsActive) {
    return null;
  }

  return (
    <GuestGuideActionButton
      icon={<Bell size={32} />}
      onClick={handleClick}
    >
      <Box textAlign="left">
        <TextV2 typographyVariant="button2">{isFarOut ? tq`Too early to book? We'll keep watch.` : tq`Book at the right time`}</TextV2>
        <TextV2
          marginTop={2}
          typographyVariant="label2"
          color="mono12"
        >
          {isFarOut
            ? tq`Hotel rates often change before the event. We'll text you when it looks like a better time to check again.`
            : tq`We'll text you when hotel prices for this event change and it's worth taking a look.`}
        </TextV2>
      </Box>
    </GuestGuideActionButton>
  );
};
